import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "../../../../services/data.service";
import { SpinnerService } from "shared-components";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
  selector: "app-grid-central-avisos",
  templateUrl: "./grid-central-avisos.component.html",
})
export class GridCentralAvisosComponent implements OnInit {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public labels;
  public data;
  public dataDisplayed: any;
  public dataExpedicionCeroDias;
  public dataExpedicionCeroDiasDisplayed: any;

  public showExpedicionCero = false;
  public showExpedicionDesignados = false;
  public showReetiquetados = false;
  public showEtiquetasReimpresas = false;
  public showConfecciones = false;
  public showDenominacionesBloqueadas = false;
  public showFallosConexion = false;
  public showUsuariosActivos = false;
  public showActivosImprimiendo = false;
  public showAlmacenes = false;

  public columnId: number;

  @Input() titulo: string;
  @Input() dataExpedicionCero?;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() emitDataExpedicionCero = new EventEmitter<any>();

  filtersVisible = false;
  public filtersForm: FormGroup;
  public paises: any;
  public denominaciones: any;
  public etiquetadores: any;
  public roles: any;

  constructor(
    private readonly fb: FormBuilder,
    private readonly _translate: TranslateService,
    private readonly _dataService: DataService,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService
  ) {
    this.filtersForm = this.fb.group({});
  }

  ngOnInit() {
    if (!this.reuseExpedicionCeroData()) {
      this.expedicionCeroTable();
      this.expedicionDesignadosTable();
      this.reetiquetadosTable();
      this.etiquetasTable();
      this.confeccionesTable();
      this.denominacionesBloqueadasTable();
      this.fallosConexionTable();
      this.usuariosActivosTable();
      this.activosImprimiendoTable();
      this.almacenesTable();
    }
    this.configureFilters();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  shareCheckedListPaises(item: any[]) {
    this.filtersForm.get("pais").patchValue(item);
  }

  shareCheckedListDenominaciones(item: any[]) {
    this.filtersForm.get("denominacion").patchValue(item);
  }

  shareCheckedListEtiquetadores(item: any[]) {
    this.filtersForm.get("etiquetador").patchValue(item);
  }

  /* shareCheckedListRoles(item: any[]) {
    this.filtersForm.get("rol").patchValue(item);
  } */

  clearFormGroup(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) =>
      formGroup.removeControl(key)
    );
  }

  private configureFilters() {
    // Clear formGroup before add new controls.
    this.clearFormGroup(this.filtersForm);

    if (
      this.showExpedicionCero ||
      this.showConfecciones ||
      this.showDenominacionesBloqueadas ||
      this.showFallosConexion ||
      this.showReetiquetados ||
      this.showExpedicionDesignados ||
      this.showEtiquetasReimpresas
    ) {
      this.filtersForm.addControl("pais", new FormControl([]));
      this.filtersForm.addControl("denominacion", new FormControl([]));
      this.filtersForm.addControl("etiquetador", new FormControl([]));
    }
    if (this.showExpedicionDesignados) {
      this.filtersForm.addControl("porcentajeEtiquetado", new FormControl(""));
    }
    if (this.showReetiquetados) {
      this.filtersForm.addControl(
        "porcentajeReetiquetado",
        new FormControl("")
      );
    }
    if (this.showEtiquetasReimpresas) {
      this.filtersForm.addControl("reimpresiones", new FormControl([]));
    }
    if (this.showUsuariosActivos) {
      //Login Web
      this.filtersForm.addControl("usuario", new FormControl(""));
      this.filtersForm.addControl("nombre", new FormControl(""));
      this.filtersForm.addControl("apellido", new FormControl(""));
    }
    if (this.showActivosImprimiendo) {
      this.filtersForm.addControl("etiquetador", new FormControl([]));
    }
    if (this.showAlmacenes) {
      this.filtersForm.addControl("etiquetador", new FormControl([]));
      this.filtersForm.addControl("numAlmacenes", new FormControl(""));
    }
  }

  public filtrar() {
    const selectedPaises = this.filtersForm.get("pais")?.value;
    const selectedDenominaciones = this.filtersForm.get("denominacion")?.value;
    const selectedEtiquetadores = this.filtersForm.get("etiquetador")?.value;
    const porcentajeEtiquetado = this.filtersForm.get(
      "porcentajeEtiquetado"
    )?.value;
    const reimpresiones = this.filtersForm.get("reimpresiones")?.value;
    const porcentajeReetiquetado = this.filtersForm.get(
      "porcentajeReetiquetado"
    )?.value;
    const numAlmacenes = this.filtersForm.get("numAlmacenes")?.value;
    const nombre = this.filtersForm.get("nombre")?.value;
    const apellido = this.filtersForm.get("apellido")?.value;
    const usuario = this.filtersForm.get("usuario")?.value;

    // Reset displayed data && filter data
    if (this.showExpedicionCero) {
      this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;

      if (selectedPaises && selectedPaises.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedPaises,
          "paisId"
        );
      }

      if (selectedDenominaciones && selectedDenominaciones.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedDenominaciones,
          "denominacionId"
        );
      }

      if (selectedEtiquetadores && selectedEtiquetadores.length > 0) {
        this.dataExpedicionCeroDiasDisplayed = this.filterDataByIds(
          this.dataExpedicionCeroDiasDisplayed,
          selectedEtiquetadores,
          "etiquetadorId"
        );
      }
    } else {
      this.dataDisplayed = this.data;

      if (selectedPaises && selectedPaises.length > 0) {
        this.dataDisplayed = this.filterDataByIds(
          this.dataDisplayed,
          selectedPaises,
          "paisId"
        );
      }

      if (selectedDenominaciones && selectedDenominaciones.length > 0) {
        this.dataDisplayed = this.filterDataByIds(
          this.dataDisplayed,
          selectedDenominaciones,
          "denominacionId"
        );
      }

      if (selectedEtiquetadores && selectedEtiquetadores.length > 0) {
        this.dataDisplayed = this.filterDataByIds(
          this.dataDisplayed,
          selectedEtiquetadores,
          "etiquetadorId"
        );
      }

      if (porcentajeEtiquetado) {
        this.dataDisplayed = this.filterDataByNumber(
          this.dataDisplayed,
          porcentajeEtiquetado,
          "porcentaje"
        );
      }

      if (porcentajeReetiquetado) {
        this.dataDisplayed = this.filterDataByNumber(
          this.dataDisplayed,
          porcentajeReetiquetado,
          "porcentaje"
        );
      }

      if (reimpresiones) {
        this.dataDisplayed = this.filterDataByNumber(
          this.dataDisplayed,
          reimpresiones,
          "numeroEtiquetasReimpresas"
        );
      }

      if (numAlmacenes) {
        this.dataDisplayed = this.filterDataByNumber(
          this.dataDisplayed,
          numAlmacenes,
          "numeroAlmacenes"
        );
      }

      if (nombre) {
        this.dataDisplayed = this.filterDataByText(
          this.dataDisplayed,
          nombre,
          "nombre"
        );
      }
      if (apellido) {
        this.dataDisplayed = this.filterDataByText(
          this.dataDisplayed,
          apellido,
          "apellido"
        );
      }
      if (usuario) {
        this.dataDisplayed = this.filterDataByText(
          this.dataDisplayed,
          usuario,
          "userName"
        );
      }
    }

    // Update paginator table
    this.firstItemList = 0;
    this.currentPage = 1;
    this.lastItemList = this.itemsPerPage;
    this.totalItems = this.showExpedicionCero
      ? this.dataExpedicionCeroDiasDisplayed.length
      : this.dataDisplayed.length;
  }

  private filterDataByIds(data: any[], selectedIds: number[], key: string) {
    if (!selectedIds || selectedIds.length === 0) {
      return data; // Si no hay IDs seleccionados, no filtrar los datos
    }
    return data.filter((item) => selectedIds.includes(item[key]));
  }

  private filterDataByNumber(data: any[], threshold: number, key: string) {
    return data.filter((item) => item[key] > threshold);
  }

  private filterDataByText(data: any[], text: string, key: string) {
    if (!text) {
      return data; // Si no hay texto, no filtrar los datos
    }
    text = text.toLowerCase();
    return data.filter(
      (item) => item[key] && item[key].toLowerCase().includes(text)
    );
  }

  private fillMutliPaisDenomEtiq() {
    this.paises = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desPais",
      "paisId"
    );
    this.denominaciones = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desDenominacion",
      "denominacionId"
    );
    this.etiquetadores = this.getUniqueValues(
      this.showExpedicionCero ? this.dataExpedicionCeroDias : this.data,
      "desEtiquetador",
      "etiquetadorId"
    );
  }

  private reuseExpedicionCeroData() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionCero.label"
      ) +
        " " +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.subLabel30"
        )
    ) {
      if (this.dataExpedicionCero) {
        this.dataExpedicionCeroDias =
          this.dataExpedicionCero.lsCeroKg_30Dias.lista;
        this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
        this.totalItems =
          this.dataExpedicionCero.lsCeroKg_30Dias.paginacionMeta.totalCount;
        this.showExpedicionCero = true;
        // Manage Filters
        this.fillMutliPaisDenomEtiq();
        return true;
      }
    } else if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel45"
          ) &&
      this.dataExpedicionCero
    ) {
      this.dataExpedicionCeroDias =
        this.dataExpedicionCero.lsCeroKg_45Dias.lista;
      this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
      this.totalItems =
        this.dataExpedicionCero.lsCeroKg_45Dias.paginacionMeta.totalCount;
      this.showExpedicionCero = true;
      // Manage Filters
      this.fillMutliPaisDenomEtiq();
      return true;
    } else if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel60"
          ) &&
      this.dataExpedicionCero
    ) {
      this.dataExpedicionCeroDias =
        this.dataExpedicionCero.lsCeroKg_60Dias.lista;
      this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
      this.totalItems =
        this.dataExpedicionCero.lsCeroKg_60Dias.paginacionMeta.totalCount;
      this.showExpedicionCero = true;
      // Manage Filters
      this.fillMutliPaisDenomEtiq();
      return true;
    } else {
      return false;
    }
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
    //this.showCorrectTable();
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = items;
    this.firstItemList = 0;
    this.lastItemList = items;
    //this.showCorrectTable();
  }

  private getExpedicionCeroGrid() {
    this.showExpedicionCero = true;
    this._spinnerService.showSpinner();
    const filters = {};
    this._dataService
      .getKilosExpedicionCeroTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.data = resp;
          if (
            this.titulo ===
            this._translate.instant(
              "central-avisos.etiquetadores.expedicionCero.label"
            ) +
              " " +
              this._translate.instant(
                "central-avisos.etiquetadores.expedicionCero.subLabel30"
              )
          ) {
            this.dataExpedicionCeroDias = resp.lsCeroKg_30Dias.lista;
            this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
            this.totalItems = resp.lsCeroKg_30Dias.paginacionMeta.totalCount;
            // Manage Filters
            this.fillMutliPaisDenomEtiq();
          } else if (
            this.titulo ===
            this._translate.instant(
              "central-avisos.etiquetadores.expedicionCero.label"
            ) +
              " " +
              this._translate.instant(
                "central-avisos.etiquetadores.expedicionCero.subLabel45"
              )
          ) {
            this.dataExpedicionCeroDias = resp.lsCeroKg_45Dias.lista;
            this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
            this.totalItems = resp.lsCeroKg_45Dias.paginacionMeta.totalCount;
            // Manage Filters
            this.fillMutliPaisDenomEtiq();
          } else if (
            this.titulo ===
            this._translate.instant(
              "central-avisos.etiquetadores.expedicionCero.label"
            ) +
              " " +
              this._translate.instant(
                "central-avisos.etiquetadores.expedicionCero.subLabel60"
              )
          ) {
            this.dataExpedicionCeroDias = resp.lsCeroKg_60Dias.lista;
            this.dataExpedicionCeroDiasDisplayed = this.dataExpedicionCeroDias;
            this.totalItems = resp.lsCeroKg_60Dias.paginacionMeta.totalCount;
            // Manage Filters
            this.fillMutliPaisDenomEtiq();
          }
        }
      });
  }

  private getExpedicionDesignadosGrid(porcentajes, operador) {
    let filters;
    this.showExpedicionDesignados = true;
    if (operador === "=") {
      filters = {
        operadorIgualdad: true,
      };
    } else {
      filters = {
        porcentajeMin: porcentajes.min ? porcentajes.min : null,
        porcentajeMax: porcentajes.max ? porcentajes.max : null,
      };
    }

    this._spinnerService.showSpinner();
    this._dataService
      .getKilosExpedicionRespectoDesignadosTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.fillMutliPaisDenomEtiq();
        }
      });
  }

  public getReetiquetadosGrid(porcentajes) {
    let filters;
    this.showReetiquetados = true;
    if (porcentajes.max) {
      filters = {
        porcentajeMin: porcentajes.min,
        porcentajeMax: porcentajes.max,
      };
    } else if (!porcentajes.max) {
      filters = {
        porcentajeMin: porcentajes.min,
      };
    }
    this._spinnerService.showSpinner();
    this._dataService
      .getKilosReetiquetadosTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.fillMutliPaisDenomEtiq();
        }
      });
  }

  public getEtiquetasGrid(tipo) {
    let filters;
    this.showEtiquetasReimpresas = true;
    if (tipo === 1) {
      filters = {
        numeroMin: 1000,
        numeroMax: 3000,
      };
    } else if (tipo === 2) {
      filters = {
        numeroMin: 3000,
        numeroMax: 5000,
      };
    } else if (tipo === 3) {
      filters = {
        numeroMin: 5000,
      };
    }
    this._spinnerService.showSpinner();
    this._dataService
      .getEtiquetasReimpresasTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.fillMutliPaisDenomEtiq();
        }
      });
  }

  public getConfeccionesGrid() {
    let filters = {};
    this.showConfecciones = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getConfeccionesTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.fillMutliPaisDenomEtiq();
        }
      });
  }

  public getDenominacionesBloqueasGrid() {
    let filters = {};
    this.showDenominacionesBloqueadas = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getDenominacionesBloqueadasTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.fillMutliPaisDenomEtiq();
        }
      });
  }

  public getFallosConexionGrid() {
    let filters = {};
    this.showFallosConexion = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getFallosConexionServidorTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.fillMutliPaisDenomEtiq();
        }
      });
  }

  public getUsuariosActivosGrid() {
    let filters = {};
    this.showUsuariosActivos = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getUsuariosActivosWebTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
        }
      });
  }

  public getActivosImprimiendoGrid() {
    let filters = {};
    this.showActivosImprimiendo = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getEtiquetadoresImprimiendoTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.etiquetadores = this.getUniqueValues(
            this.data,
            "desEtiquetador",
            "etiquetadorId"
          );
        }
      });
  }

  public getAlmacenesGrid() {
    let filters = {
      numeroMin: 2,
      numeroMax: null,
    };
    this.showAlmacenes = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getAlmacenesTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          // Manage Filters
          this.etiquetadores = this.getUniqueValues(
            this.data,
            "lsDesAlmacen",
            "id"
          );
        }
      });
  }

  private getUniqueValues(data: any[], key: string, idKey: string) {
    // Crea un mapa para almacenar los valores únicos
    const uniqueMap = new Map();

    // Itera sobre los datos y almacena los valores únicos en el mapa
    data.forEach((item) => {
      if (!uniqueMap.has(item[key])) {
        uniqueMap.set(item[key], item[idKey]);
      }
    });

    // Convierte el mapa en un array con la estructura deseada
    let uniqueArray = Array.from(uniqueMap, ([des, id]) => ({ id, des }));

    // Ordena el array alfabéticamente por la propiedad 'des'
    uniqueArray.sort((a, b) => {
      if (a.des.toLowerCase() < b.des.toLowerCase()) {
        return -1;
      }
      if (a.des.toLowerCase() > b.des.toLowerCase()) {
        return 1;
      }
      return 0;
    });

    return uniqueArray;
  }

  public expedicionCeroTable() {
    if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel30"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel45"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel60"
          )
    ) {
      this.getExpedicionCeroGrid();
    }
  }

  public expedicionDesignadosTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionDesignados.preLabel"
      ) +
        "=" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " "
    ) {
      this.getExpedicionDesignadosGrid({}, "=");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionDesignados.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " (<50%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: null, max: 50 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionDesignados.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " (50%-75%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 50, max: 75 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionDesignados.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " (15%-20%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 115, max: 120 }, ">");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionDesignados.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " (20%-25%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 120, max: 125 }, ">");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.expedicionDesignados.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionDesignados.postLabel"
        ) +
        " (>25%)"
    ) {
      this.getExpedicionDesignadosGrid({ min: 125, max: null }, ">");
    }
  }

  public reetiquetadosTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.reetiquetado.label"
      ) +
        " (10%-15%)"
    ) {
      this.getReetiquetadosGrid({ min: 10, max: 15 });
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.reetiquetado.label"
      ) +
        " (15%-20%)"
    ) {
      this.getReetiquetadosGrid({ min: 15, max: 20 });
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.reetiquetado.label"
      ) +
        " (>20%)"
    ) {
      this.getReetiquetadosGrid({ min: 20, max: null });
    }
  }

  public etiquetasTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.etiquetasReimpresas.label"
      ) +
        " (1.000-3.000)"
    ) {
      this.getEtiquetasGrid(1);
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.etiquetasReimpresas.label"
      ) +
        " (3.000-5.000)"
    ) {
      this.getEtiquetasGrid(2);
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.etiquetasReimpresas.label"
      ) +
        " (>5.000)"
    ) {
      this.getEtiquetasGrid(3);
    }
  }

  public confeccionesTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.confecciones.label"
      ) +
        " "
    ) {
      this.getConfeccionesGrid();
    }
  }

  public denominacionesBloqueadasTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.denominacionesBloqueadas.label"
      ) +
        " "
    ) {
      this.getDenominacionesBloqueasGrid();
    }
  }

  public fallosConexionTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.fallosConexion.label"
      ) +
        " "
    ) {
      this.getFallosConexionGrid();
    }
  }

  public usuariosActivosTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.usuariosActivos.label"
      ) +
        " "
    ) {
      this.getUsuariosActivosGrid();
    }
  }

  public activosImprimiendoTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.etiquetadores.activosImprimiendo.label"
      ) +
        " "
    ) {
      this.getActivosImprimiendoGrid();
    }
  }

  public almacenesTable() {
    if (
      this.titulo ===
      this._translate.instant("central-avisos.etiquetadores.almacenes.label") +
        " "
    ) {
      this.getAlmacenesGrid();
    }
  }

  public showCorrectTable() {
    if (this.showExpedicionCero) {
      this.expedicionCeroTable();
    } else if (this.showExpedicionDesignados) {
      this.expedicionDesignadosTable();
    } else if (this.showReetiquetados) {
      this.reetiquetadosTable();
    } else if (this.showEtiquetasReimpresas) {
      this.etiquetasTable();
    } else if (this.showConfecciones) {
      this.confeccionesTable();
    } else if (this.showDenominacionesBloqueadas) {
      this.denominacionesBloqueadasTable();
    } else if (this.showFallosConexion) {
      this.fallosConexionTable();
    } else if (this.showUsuariosActivos) {
      this.usuariosActivosTable();
    } else if (this.showActivosImprimiendo) {
      this.activosImprimiendoTable();
    } else if (this.showAlmacenes) {
      this.almacenesTable();
    }
  }

  public close() {
    this.refresh.emit(true);

    if (
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel30"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel45"
          ) ||
      this.titulo ===
        this._translate.instant(
          "central-avisos.etiquetadores.expedicionCero.label"
        ) +
          " " +
          this._translate.instant(
            "central-avisos.etiquetadores.expedicionCero.subLabel60"
          )
    ) {
      this.emitDataExpedicionCero.emit(this.data);
    } else {
      this.emitDataExpedicionCero.emit();
    }
  }

  public toOrderBy(id: number) {
    this.columnId = id;
  }

  public getSortIcon(id: number) {
    let iconClass = "fa fa-sort";
    if (id === this.columnId) {
      const selectedColumn = document.querySelectorAll("th")[id - 1];
      iconClass =
        selectedColumn.dataset.order === "desc"
          ? "fa fa-sort-up"
          : "fa fa-sort-down";
    }
    return iconClass;
  }
}
